@if (isShown) {
<div
  [class.collapsed]="isCollapsed$ | async"
  [class.dropdown-open]="dropdownOpen$ | async"
  [class]="levelClass"
  class="sidenav-item"
>
  @if (item.type === 'subheading') {
  <div
    [class]="item.customClass"
    class="subheading"
  >
    {{ item.name }}
  </div>
  } @else { @if ( item.subItems?.length > 0 || isFunction(item.routeOrFunction)) {
  <a
    (click)="handleClick()"
    class="sidenav-item-link bbb"
    fxLayout="row"
    fxLayoutAlign="start center"
    matRipple
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
  } @else { @if (!item.href) {
  <a
    [routerLinkActiveOptions]="{ exact: item.pathMatchExact || false }"
    [routerLink]="item.routeOrFunction"
    class="sidenav-item-link"
    fxLayout="row"
    fxLayoutAlign="start center"
    matRipple
    routerLinkActive="active"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
  } @else {
  <a
    href="{{ item.href }}"
    target="{{ item.target }}"
    class="sidenav-item-link"
    fxLayout="row"
    fxLayoutAlign="start center"
    matRipple
    routerLinkActive="active"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
  } } }
  <ng-template #linkContent>
    @if (level === 0) {
    <i class="icon mdi s16 {{ item.icon }}"></i>
    }
    <!-- <mat-icon *ngIf="level === 0" class="icon">{{ item.icon }}</mat-icon> -->
    @if (level > 0) {
    <div
      class="text-icon"
      fxFlex="none"
    ></div>
    } @if (level > 0 && item.icon) {
    <i class="icon mdi s16 {{ item.icon }} sub-icon"></i>
    }
    <span
      class="name"
      [translate]="item.name"
    ></span>
    <span fxFlex><!-- fill space --></span>
    @if (item.badge) {
    <span
      [style.background-color]="item.badgeColor"
      class="badge"
      >{{ item.badge }}</span
    >
    } @if (item.subItems && item.subItems.length > 0) {
    <mat-icon
      [class.rotate]="dropdownOpen$ | async"
      class="expand-indicator"
    >
      expand_more
    </mat-icon>
    }
  </ng-template>
  <div
    [@dropdownOpen]="dropdownOpen$ | async"
    class="dropdown"
    fxLayout="column"
  >
    @for (subItem of item.subItems; track $index) {
    <fury-sidenav-item
      [item]="subItem"
      [level]="level + 1"
    ></fury-sidenav-item>
    }
  </div>
</div>
}
